export class PartnerProfile {
  constructor({ kind, prepaidCardsAllowed }) {
    Object.assign(this, {
      kind,
      prepaidCardsAllowed,
    });
  }
}
